export default {
    TODOS: 1,
    BAIRRO: 2,
    FAIXA_ETARIA: 3,
}